
import {  DocumentNode } from "graphql"
import { useAppoloStore, useMainStore } from "../../../settings/zustand" 
import { 
    getChangeName,
    getInputTypeName,
    getMutationArgs,
    getQueryArgs, 
    getQueryName, 
    mutationEdit, 
    querySingle, 
    querySingleName, 
} from "src/libs/layouts" 
import {  
    GET_EXTERNAL_LANDING_ACTION,
    GET_FB_GOODS_ACTION,
    GET_LOCAL_LANDING_ACTION,
    GET_WEBSITE_TAGS,
    UPDATE_EXTERNAL_LANDING_ACTION
} from "./actionTypes"  
const { gql } = require("@apollo/client/core")

const asyncControllers =  async(action:string, data: any) => {
    let response : any, 
        query : DocumentNode,
        query_name : string, mutation: any, fields : any,
        _query: any
        
    const apolloClient: any = useAppoloStore.getState().client
    switch( action )
    {
        case GET_LOCAL_LANDING_ACTION:   
            return fetch( data.url ).then(resp => resp.json()) 
        case GET_EXTERNAL_LANDING_ACTION:
             query_name = `query getPELandingPage($id: String, $land_id: ID) {
                getPELandingPage(id: $id, land_id: $land_id) {
                    id
                    json
                    title
                    __typename
                }
            }
            `
            query = gql`${ query_name }`  
            response = await apolloClient.query({
                query,
                variables : data
            })
            return response
        case UPDATE_EXTERNAL_LANDING_ACTION:   
            query_name = `mutation changePELandingPage(
                $id: String, 
                $input: PELandingPageInput, 
                $land_id: ID
                ) {
                changePELandingPage(id: $id, land_id: $land_id, input: $input) {
                    id
                    json
                    title
                    __typename
                }
            }`
            mutation = gql`${ query_name }`  
            response = await apolloClient.mutate({
                mutation,
                variables : data
            })
            return response
        case GET_FB_GOODS_ACTION:   
            return fetch(data.goods).then(
                resp => resp.text(), 
                err  => err,
            )
        case GET_WEBSITE_TAGS: 
            query_name = `query getExternalWebsiteTags {
                getExternalWebsiteTags( 
                    url: "${ data.url }"
                ) {
                    title
                    description
                    keywords
                    image
                    __typename
                }
            }`
            query = gql`${ query_name }`  
            response = await apolloClient.query({
                query,
                variables : data
            })
            return response
        default: 
            return  new Promise<any>( (resolve, reject) => { resolve(`Unknown action type: ${action}`)} )
    }
}
export default asyncControllers